/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { ObjectDefinition } from "./object-definition";
import { Property } from "./property";

export class HHSeekAndFindOperation {

  id: number;

  label: String;

  encoding_type: ObjectDefinition;

  main_property: Property;

  tag_property: Property;

  enabled: Boolean;
  
}
